import { Notification } from 'react-admin'
export default Notification
